import { MappedClass, MappedProperty, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterBooleanApplicable } from './z-printer-boolean-applicable';
import { ZPrinterInt32Applicable } from './z-printer-int32-applicable';
import { ZPrinterMeanTypeApplicable } from './z-printer-mean-type-applicabile';
import { ZPrinterStringApplicable } from './z-printer-string-applicable';

@MappedClass()
export class ZPrinterFiscalConfigDepartment {
  @MappedProperty()
  index: number;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  vat_index: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterStringApplicable)
  name: ZPrinterStringApplicable;

  @MappedPropertyClass(() => ZPrinterMeanTypeApplicable)
  type: ZPrinterMeanTypeApplicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  halo: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  lalo: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterBooleanApplicable)
  single: ZPrinterBooleanApplicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  group_code: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  default_amount: ZPrinterInt32Applicable;

  @MappedPropertyClass(() => ZPrinterInt32Applicable)
  ateco_index: ZPrinterInt32Applicable;
}
